import { Flow, Text } from 'bold-ui'
import { RadioGroupField } from 'components/form'
import { CiapSelectFieldModel } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import { MotivoPrescricaoCiapSelectField } from 'components/form/field/select/CiapSelectField/MotivoPrescricaoCiapSelectField'
import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { MotivoPrescricaoCidSelectField } from 'components/form/field/select/CidSelectField/MotivoPrescricaoCidSelectField'
import { usePecField } from 'components/form/final-form/hooks/useField'
import { InfoIcon } from 'components/InfoIcon'
import { CiapCapituloEnum, SexoEnum } from 'graphql/types.generated'
import React from 'react'
import { MetaRoot } from 'util/metaPath'

import { MedicamentoFormModel, TipoMotivoPrescricaoEnum } from '../../../model-prescricao'

export interface MotivoPrescricaoSectionProps {
  name: MetaRoot<MedicamentoFormModel>
  sexoCidadao: SexoEnum | null
  idadeCidadaoEmAnos?: number
  cidsRegistrados: ReadonlyArray<CidSelectFieldModel>
  ciapsRegistrados: ReadonlyArray<CiapSelectFieldModel>
}

const PLACEHOLDER = 'Selecione um já registrado nesse atendimento ou busque por um novo'

export const MotivoPrescricaoSection = React.memo((props: Readonly<MotivoPrescricaoSectionProps>) => {
  const { name, sexoCidadao, idadeCidadaoEmAnos, cidsRegistrados, ciapsRegistrados } = props

  const { input: tipoMotivoInput } = usePecField({
    name: name.tipoMotivoPrescricao.absolutePath(),
    subscription: { value: true },
  })

  const tipoMotivoPrescricao = tipoMotivoInput.value as TipoMotivoPrescricaoEnum

  return (
    <Flow direction='vertical' gap={0} justifyItems='stretch'>
      <RadioGroupField
        name={name.tipoMotivoPrescricao.alias}
        label={
          <Flow direction='horizontal' gap={0.1}>
            <Text fontWeight='bold'>Motivo da prescrição</Text>
            <InfoIcon
              icon='infoCircleFilled'
              text='De acordo com a portaria GM/MS Nº 6.100, o motivo da prescrição é uma informação obrigatória em um Registro eletrônico de prescrição de medicamentos (REPM).'
            />
          </Flow>
        }
        options={[
          { value: TipoMotivoPrescricaoEnum.CID10, label: 'CID 10' },
          { value: TipoMotivoPrescricaoEnum.CIAP2, label: 'CIAP 2' },
        ]}
      />

      {tipoMotivoPrescricao === TipoMotivoPrescricaoEnum.CID10 ? (
        <MotivoPrescricaoCidSelectField
          name={name.cidMotivoPrescricao.alias}
          label='CID 10'
          placeholder={PLACEHOLDER}
          sexo={sexoCidadao}
          idadeCidadaoEmAnos={idadeCidadaoEmAnos}
          itensRegistrados={cidsRegistrados}
          required
          popperProps={{ strategy: 'fixed' }}
        />
      ) : (
        <MotivoPrescricaoCiapSelectField
          name={name.ciapMotivoPrescricao.alias}
          label='CIAP 2'
          placeholder={PLACEHOLDER}
          sexo={sexoCidadao}
          idadeCidadaoEmAnos={idadeCidadaoEmAnos}
          capitulosExcluidos={[CiapCapituloEnum.PROCEDIMENTOS]}
          excluirCIAPsDAB
          itensRegistrados={ciapsRegistrados}
          required
          popperProps={{ strategy: 'fixed' }}
        />
      )}
    </Flow>
  )
})
